module.exports = __webpack_public_path__ + "static/media/End.14990581.svg";